import { render, staticRenderFns } from "./StepToolbar.vue?vue&type=template&id=2527bfd0"
import script from "./StepToolbar.vue?vue&type=script&lang=js"
export * from "./StepToolbar.vue?vue&type=script&lang=js"
import style0 from "./StepToolbar.vue?vue&type=style&index=0&id=2527bfd0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports